import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShuffle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14 20V18H16.6L13.425 14.825L14.85 13.4L18 16.55V14H20V20H14ZM5.4 20L4 18.6L16.6 6H14V4H20V10H18V7.4L5.4 20ZM9.175 10.575L4 5.4L5.4 4L10.575 9.175L9.175 10.575Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgShuffle);
export default ForwardRef;
